import { render, staticRenderFns } from "./taxGuide.vue?vue&type=template&id=3fa80b34&scoped=true&"
import script from "./taxGuide.js?vue&type=script&lang=js&"
export * from "./taxGuide.js?vue&type=script&lang=js&"
import style0 from "./taxGuide.css?vue&type=style&index=0&id=3fa80b34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa80b34",
  null
  
)

export default component.exports